<app-loader [isLoading]="isLoading$ | async"></app-loader>
<router-outlet></router-outlet>
